<template>
    <v-layout justify-center>
        <v-responsive max-width="1140px" width="100%" height="100%" class="px-1">
            <div class="headline text-start mt-8">
                <span>e커머스피칭페스타 소개</span>
            </div>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">행사 소개</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea v-model="festa.section2.txt[0]" outlined hide-details rows="2" />
                    </v-card-text>
                    <v-card-text>
                        <v-textarea v-model="festa.section2.txt[1]" outlined hide-details />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">행사 개요</div>
                    <v-spacer/>
                </v-layout>

                <v-card class="mt-2">
                    <v-row :key="index" align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" @click="$set(festa.section3.table.list, festa.section3.table.list.length, {})" class="mr-4"><v-icon left size="16">mdi-plus</v-icon>추가</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider />

                    <v-card-text class="py-0">
                        <template v-for="item, index in festa.section3.table.list">
                            <v-row :key="index" align="center">
                                <v-col cols="2">
                                    <v-textarea v-model="item.title" rows="1" dense outlined hide-details />
                                </v-col>
                                <v-col>
                                    <v-textarea v-model="item.input" rows="1" dense outlined hide-details />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn small outlined color="red" @click="festa.section3.table.list.splice(index, 1)"><v-icon left size="16">mdi-delete-outline</v-icon>삭제</v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">개최 성과</div>
                </v-layout>

                <v-card class="mt-2">
                    <v-card-text>
                        <v-textarea v-model="festa.section4.txt[0]" outlined hide-details rows="2" />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">프로그램</div>
                </v-layout>

                <v-card class="mt-2">
                    <v-card-text>
                        <v-textarea v-model="festa.section5.txt[0]" outlined hide-details rows="2" />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">Partners <span class="font-weight-regular">이미지사이즈 : 294x96(px)</span></div>
                </v-layout>

                <v-card class="mt-2">
                    <v-card-text>
                        <v-textarea v-model="festa.section6.contents.frame2211.txt[0]" outlined hide-details rows="2" />
                    </v-card-text>

                    <v-divider />

                    <v-row :key="index" align="center">
                        <v-spacer />
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" @click="$set(festa.section6.contents.frame2302.logoList, festa.section6.contents.frame2302.logoList.length, [])" class="mr-4"><v-icon left size="16">mdi-plus</v-icon>추가</v-btn>
                        </v-col>
                    </v-row>

                    <v-card-text class="py-0">
                        <template v-for="logo, row in festa.section6.contents.frame2302.logoList" >
                            <v-divider :key="'dividier' + row" />
                            <v-layout :key="index" align="center" align-center>
                                <v-row :key="row" align="end" class="pr-4">
                                    <template v-for="_, col in logo.length + 1">
                                        <v-col v-if="col < 4" cols="3" :key="col">
                                            <template v-if="logo[col]">
                                                <v-layout>
                                                    <v-spacer />
                                                    <v-btn icon small text @click="logo.splice(col, 1)"><v-icon>mdi-close</v-icon></v-btn>
                                                </v-layout>
                                                <v-img :src="logo[col].src" width="100%" height="96" contain />
                                                <v-text-field v-model="festa.section6.contents.frame2302.logoList[row][col].url" placeholder="https://" hide-details prepend-icon="mdi-link" />
                                            </template>
                                            <template v-else>
                                                <v-sheet outlined rounded width="100%" height="146" class="d-flex" style="cursor: pointer; border-style: dashed; border-width: 2px;" @click="$refs[`logo_${row}_${col}`]?.[0]?.$refs?.input?.click?.()">
                                                    <div class="ma-auto">
                                                        <v-icon left size="20">mdi-plus</v-icon>
                                                        <span>추가</span>
                                                    </div>
                                                </v-sheet>
                                            </template>
                                            <v-file-input :ref="`logo_${row}_${col}`" accept=".jpg, .png" class="d-none" @change="file => upload(file, row, col)" />
                                        </v-col>
                                    </template>
                                    <v-spacer />
                                </v-row>
                                <v-btn small outlined color="red" class="col-auto" @click="festa.section6.contents.frame2302.logoList.splice(row, 1)"><v-icon left size="16">mdi-delete-outline</v-icon>삭제</v-btn>
                            </v-layout>
                        </template>
                    </v-card-text>
                </v-card>
            </section>

            <v-img src="/images/console/e-festa.png" class="mt-2" width="450"></v-img>

            <v-row justify="center" class="mx-1 my-4">
                <v-col md="auto" sm="auto">
                    <v-btn dark color="blue darken-2" elevation="4" @click="save()">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {

            festa: {
                section2: {
                    txt: []
                },

                section3: {
                    table: {
                        list: []
                    }
                },

                section4: {
                    txt: []
                },

                section5: {
                    txt: []
                },

                section6: {
                    contents: {
                        frame2211: {
                            txt: []
                        },
                        frame2302: {
                            logoList: []
                        }
                    }
                }
            },

        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            let { festa } = await api.console.kea.festa.get();
            this.festa = festa ?? this.festa;
        },
        log(args){
            console.log({
                args
            });
        },
        async save(){
            await api.console.kea.festa.put(this.festa);

            alert("저장되었습니다");
        },
        async upload(file, row, col){
            let { src } = await api.resource.post(file, "/res/kea/festa");
            this.$set(this.festa.section6.contents.frame2302.logoList[row], col, { src, url: "" });
            this.$forceUpdate();
        }
    },
};
</script>
